export const homeGallery = [
  {
    src: "assets/home/gallery/Image7.jpg",
    alt: "Modelos de ropa"
  },
  {
    src: "assets/home/gallery/Image2.jpg",
    alt: "Fotografía de producto"
  },
  {
    src: "assets/home/gallery/Image3.jpg",
    alt: "Vista superior producto"
  },
  {
    src: "assets/home/gallery/Image5.jpg",
    alt: "Fotografía navideña"
  },
  {
    src: "assets/home/gallery/Image6.jpg",
    alt: "Imagen publiicidad de producto"
  },
  {
    src: "assets/home/gallery/Image8.jpg",
    alt: "Fotografía moderna con modelos"
  },
  {
    src: "assets/home/gallery/Image1.jpg",
    alt: "Publicidad para marcas"
  },
  {
    src: "assets/home/gallery/Image9.jpg",
    alt: "Modelo en sesión de fotos"
  },
  {
    src: "assets/home/gallery/Image4.jpg",
    alt: "Detalle de producto"
  }
];
